var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopAlliances(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9149 25.8333H41.0838M21.9149 25.8333C21.4276 27.4704 21.166 29.2046 21.166 31C21.166 32.7953 21.4276 34.5295 21.9149 36.1666M21.9149 25.8333C23.3853 20.8926 26.9104 16.8368 31.4993 14.6568M21.9149 36.1666H41.0838M21.9149 36.1666C23.3853 41.1073 26.9104 45.1631 31.4993 47.3431M31.4993 14.6568C29.1504 13.541 26.5228 12.9166 23.7493 12.9166C13.7622 12.9166 5.66602 21.0128 5.66602 31C5.66602 40.9871 13.7622 49.0833 23.7493 49.0833C26.5228 49.0833 29.1504 48.4589 31.4993 47.3431M31.4993 14.6568C33.8483 13.541 36.4759 12.9166 39.2493 12.9166C49.2365 12.9166 57.3327 21.0128 57.3327 31C57.3327 40.9871 49.2365 49.0833 39.2493 49.0833C36.4759 49.0833 33.8483 48.4589 31.4993 47.3431M31.4993 14.6568C37.6088 17.5591 41.8327 23.7863 41.8327 31C41.8327 38.2136 37.6088 44.4408 31.4993 47.3431",
    stroke: "url(#paint0_linear_7321_20005)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7321_20005",
    x1: 5.66602,
    y1: 31,
    x2: 57.3327,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopAlliances);
export default __webpack_public_path__ + "static/media/developAlliances.4a68e42ffcf37e3416c4ea3bac5fd180.svg";
export { ForwardRef as ReactComponent };